import(/* webpackMode: "eager" */ "/vercel/path0/apps/store/src/app/(minimalLayout)/deeplink/[[...slug]]/page.tsx");
